import React from "react";

export function BlueField({ children }: { children: React.ReactNode }) {
  return <span className="blue-field">{children}</span>;
}
